import React from "react";
import { Phone, Globe, MapPin, Mail, FileText } from "lucide-react";
import { brand, footer, media } from "../../content/siteContent";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#081321] text-white/70 border-t border-hair-dark">
    <div className="container-page py-16">
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <a
            href={footer.contact.website}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Axiom College — visit axiomcollege.com.au (opens in a new tab)"
            className="inline-block focus-ring rounded-sm"
            data-testid="footer-axiom-logo-link"
          >
            <img
              src={media.logoWhite}
              alt="Axiom College — RTO 40489"
              className="h-16 w-auto"
              data-testid="footer-axiom-logo"
            />
          </a>
          <p className="mt-6 font-display font-extrabold text-white text-lg tracking-tight">
            {brand.name}
          </p>
          <p className="mt-2 text-sm text-white/70 leading-relaxed max-w-sm">{brand.complianceLine}</p>
          <p className="mt-4 text-xs text-white/55 leading-relaxed max-w-sm">{footer.responsibility}</p>
          <p className="mt-6 font-display font-bold text-gold tracking-[0.25em] uppercase text-xs">
            {brand.tagline}
          </p>
        </div>

        <div className="lg:col-span-4">
          <p className="eyebrow text-teal mb-4">Contact</p>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-teal" />
              <a href={`tel:${footer.contact.phone.replace(/\s/g, "")}`} className="hover:text-white transition-colors duration-200">
                {footer.contact.phone}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Globe className="h-4 w-4 text-teal" />
              <a href={footer.contact.website} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-200">
                axiomcollege.com.au
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 text-teal" />
              <a href={`mailto:${footer.contact.email}`} className="hover:text-white transition-colors duration-200">
                {footer.contact.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 text-teal mt-0.5" />
              <span>
                {footer.contact.campuses}
                <span className="block text-white/45 text-xs mt-0.5">{footer.contact.campusList}</span>
              </span>
            </li>
            <li className="flex items-center gap-3">
              <FileText className="h-4 w-4 text-teal" />
              <a href={footer.contact.studentHandbookUrl} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors duration-200" data-testid="footer-handbook-link">
                Student Handbook &amp; Program Guide
              </a>
            </li>
          </ul>
        </div>

        <div className="lg:col-span-3">
          <p className="eyebrow text-teal mb-4">Legal</p>
          <ul className="space-y-3 text-sm">
            {footer.legal.map((l) => (
              <li key={l.label}>
                <a href={l.href} target="_blank" rel="noopener noreferrer" data-testid={`footer-legal-${l.label.split(" ")[0].toLowerCase()}`} className="hover:text-white transition-colors duration-200">{l.label}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-12 pt-8 border-t border-hair-dark">
        <p className="text-xs text-white/45 leading-relaxed max-w-4xl">{footer.disclaimer}</p>
        <p className="mt-3 text-xs text-white/45 leading-relaxed max-w-4xl" data-testid="footer-cricos">{footer.cricos}</p>
        <p className="mt-6 text-xs text-white/40">
          © {new Date().getFullYear()}.{" "}
          <a
            href={footer.contact.website}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition-colors duration-200 underline-offset-2 hover:underline"
            data-testid="footer-copyright-axiom-link"
          >
            Axiom College
          </a>
          . All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);
